import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51b85044&scoped=true&"
import script from "./commentfilm.js?vue&type=script&lang=js&"
export * from "./commentfilm.js?vue&type=script&lang=js&"
import style0 from "./commentfilm.scss?vue&type=style&index=0&id=51b85044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b85044",
  null
  
)

export default component.exports